import { QueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: how long data is considered fresh (5 minutes)
      staleTime: 5 * 60 * 1000,
      // Retry once, but never on client errors (4xx) or rate limits — retrying a
      // rate-limited request only compounds the throttling. Qlik 429s surface as
      // our 502 EXTERNAL_SERVICE_ERROR carrying details.upstreamStatus === 429.
      retry: (failureCount, error) => {
        const status = (error as { status?: number } | null)?.status;
        const upstreamStatus = (error as { details?: { upstreamStatus?: number } } | null)?.details
          ?.upstreamStatus;
        if (status === 429 || upstreamStatus === 429) return false;
        if (typeof status === "number" && status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
      // Refetch on window focus for fresh data
      refetchOnWindowFocus: true,
    },
    mutations: {
      // Do not retry mutations - they should only run once
      retry: false,
      onError: (error) => {
        Sentry.captureException(error);
      },
    },
  },
});
